angular.module('main').directive('thCalendarMonth', [
	'$filter',
	function() {
		return {
			restrict: 'AE',
			template:
				'<table>' +
				'<tr>' +
				'<td class="td-head"><div>{{thisDay}}</div></td>' +
				'</tr>' +
				'</table>',
			scope: {
				day: '=snDay'
			},
			replace: true,
			transclude: true,
			link(scope) {
				const _month = scope.day.getMonth();
				scope.thisDay = scope.day.getDate();

				if (scope.thisDay === 1) {
					const monthShortNames = [
						'Jan',
						'Feb',
						'Mar',
						'Apr',
						'May',
						'Jun',
						'Jul',
						'Aug',
						'Sep',
						'Oct',
						'Nov',
						'Dec'
					];
					scope.thisDay += ` ${monthShortNames[_month]}`;
				}
			}
		};
	}
]);



// WEBPACK FOOTER //
// ./web/js/components/PageCalendar/thCalendarMonth.js